export default __webpack_public_path__ + "static/media/footer-menu-03.f7b4e498.svg";